import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import TodayUpdates from "@/pages/home/components/TodayUpdates";
import HotSeries from "@/pages/home/components/HotSeries";
import Reminder from "@/pages/home/components/Reminder";
import Categories from "@/pages/home/components/Categories";
import Faq from "@/pages/home/components/Faq";
import About from "@/pages/home/components/About";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TodayUpdates />
        <HotSeries />
        <Reminder />
        <Categories />
        <Faq />
        <About />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}